import api from './axios';

export const fetchPendingStaffRegistrations = (params) =>
  api.get('/staff/pending-registrations', { params }).then((r) => r.data);

export const fetchPendingLinkRequests = () =>
  api.get('/staff/pending-link-requests').then((r) => r.data);

export const cancelLinkRequest = (permissionId) =>
  api.delete(`/staff/pending-link-requests/${permissionId}`).then((r) => r.data);

export const fetchMyStaffInvitations = () =>
  api.get('/staff/membership-invitations').then((r) => r.data);

export const acceptStaffInvitation = (permissionId) =>
  api.post(`/staff/membership-invitations/${permissionId}/accept`).then((r) => r.data);

export const declineStaffInvitation = (permissionId) =>
  api.post(`/staff/membership-invitations/${permissionId}/decline`).then((r) => r.data);

export const approveStaffRegistration = (permissionId) =>
  api.post(`/staff/pending-registrations/${permissionId}/approve`).then((r) => r.data);

export const rejectStaffRegistration = (permissionId) =>
  api.post(`/staff/pending-registrations/${permissionId}/reject`).then((r) => r.data);

export const fetchStaff = (params) => api.get('/staff', { params }).then((r) => r.data);

export const fetchStaffSuggestions = (params) =>
  api.get('/staff/suggestions', { params }).then((r) => r.data);

export const fetchStaffDirectory = (params) =>
  api.get('/staff/directory', { params }).then((r) => r.data);

export const linkStaff = (body) => api.post('/staff/link', body).then((r) => r.data);

export const inviteStaff = (body) => api.post('/staff/invite', body).then((r) => r.data);

export const updateStaffPermissions = (staffId, permissions) =>
  api.put(`/staff/${staffId}/permissions`, permissions).then((r) => r.data);

export const updateStaffSpecialties = (staffId, payload) =>
  api
    .put(`/staff/${staffId}/specialties`, typeof payload === 'object' ? payload : { serviceIds: payload })
    .then((r) => r.data);

export const updateStaffBranchSchedules = (staffId, branchSchedules) =>
  api.put(`/staff/${staffId}/branch-schedules`, { branchSchedules }).then((r) => r.data);

export const deactivateStaff = (staffId) =>
  api.delete(`/staff/${staffId}`).then((r) => r.data);

export const reactivateStaff = (staffId) =>
  api.put(`/staff/${staffId}/reactivate`).then((r) => r.data);

export const fetchStaffActivity = (staffId, params) =>
  api.get(`/staff/${staffId}/activity`, { params }).then((r) => r.data);

export const fetchStaffDashboard = () => api.get('/staff/dashboard').then((r) => r.data);

export const fetchStaffSalary = (staffId) =>
  api.get(`/staff/${staffId}/salary`).then((r) => r.data);

export const updateStaffSalary = (staffId, salary) =>
  api.put(`/staff/${staffId}/salary`, salary).then((r) => r.data);

export const fetchSalaryChangeRequests = () =>
  api.get('/staff/salary-change-requests').then((r) => r.data);

export const approveSalaryChange = (requestId) =>
  api.post(`/staff/salary-change-requests/${requestId}/approve`).then((r) => r.data);

export const rejectSalaryChange = (requestId, rejectionReason) =>
  api.post(`/staff/salary-change-requests/${requestId}/reject`, { rejectionReason }).then((r) => r.data);
